import React from 'react';
import {
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuItemOption,
	MenuGroup,
	MenuOptionGroup,
	MenuDivider,
	IconButton,
} from '@chakra-ui/react';
import { UilSync } from '@iconscout/react-unicons';
import _ from 'lodash';
import { selectedComponent } from '../../../redux/selectedComponentSlice';
import { useSelector, useDispatch } from 'react-redux';
import { componentProps } from '../../../utils/componentsDictionary';
import { updateComponent } from '../../../redux/pagesSlice';
import { selectedPage } from '../../../redux/selectedPageSlice';
import { selectComponent } from '../../../redux/selectedComponentSlice';
import { mergeComponentWithDefault, mergeVariables } from '../../../utils/functions';
import components from '../../../utils/componentsDictionary';

//chakra menu that has one button and 2 menu items
//resetcomponent partial and full as items
const MenuResetComponent = () => {
	const { props: component } = useSelector(selectedComponent);
	const selectedPageValue = useSelector(selectedPage);
	const dispatch = useDispatch();

	const resetFull = () => {
		const componentProps = components.find((comp) => comp.componentName === component.componentGroup).componentProps;
		const resetedComp = componentProps(component?.templateId || 1);

		resetedComp.componentId = component.componentId;
		dispatch(
			updateComponent({
				component: resetedComp,
				componentId: component.componentId,
				pageId: selectedPageValue,
			}),
		);
		dispatch(selectComponent(null));
	};

	const resetPartial = () => {
		const componentProps = components.find((comp) => comp.componentName === component.componentGroup).componentProps;
		const resetedComp = componentProps(component?.templateId || 1);

		//css variables first
		// resetedComp.variables = _.unionBy(component.variables,resetedComp.variables);
		const mergedComp = mergeComponentWithDefault(resetedComp, component);

		mergedComp.variables = mergeVariables(resetedComp.variables, component.variables);
		mergedComp.componentId = component.componentId;
		dispatch(
			updateComponent({
				component: mergedComp,
				componentId: component.componentId,
				pageId: selectedPageValue,
			}),
		);
		dispatch(selectComponent(null));
	};

	return (
		<Menu>
			<MenuButton as={IconButton} variant="outline" size="sm" icon={<UilSync size={18} />}>
				Resetar componente
			</MenuButton>
			<MenuList>
				<MenuItem onClick={resetPartial}>Resetar</MenuItem>
				<MenuItem onClick={resetFull} color={'red'}>
					Resetar totalmente
				</MenuItem>
			</MenuList>
		</Menu>
	);
};

export default MenuResetComponent;
